const CandidateInterviewPage = () => import('@/pages/candidate/interview/CandidateInterviewPage.vue')
const CandidateInterviewDone = () => import('@/pages/candidate/interview/_slug/CandidateInterviewDonePage.vue')
const CandidateInterviewCongrats = () => import('@/pages/candidate/interview/_slug/CandidateInterviewCongratsPage.vue')

export default [
  {
    path: 'candidate/interview/:slug',
    alias: 'i/:slug',
    name: 'CandidateInterview',
    component: CandidateInterviewPage,
    meta: {
      layout: 'empty',
      requiresAuth: false
    }
  },
  {
    path: 'candidate/interview/:slug/done',
    name: 'CandidateInterviewDone',
    component: CandidateInterviewDone,
    meta: {
      layout: 'empty',
      requiresAuth: false
    }
  },
  {
    path: 'candidate/interview/:slug/congrats',
    name: 'CandidateInterviewCongrats',
    component: CandidateInterviewCongrats,
    meta: {
      layout: 'empty',
      requiresAuth: false
    }
  }
]
